import request from '@/axios'
// import type { UserType } from './types'

// interface RoleParams {
//   roleName: string
// }

export const getAccountList = (data: object) => {
  return request.post({ url: '/account/list', data })
}

export const getWaterMark = (data: object) => {
  return request.post({
    url: '/common/wm/web/getWm',
    data,
    baseURL: import.meta.env.VITE_APP_BASE_API,
    hideMsg: true
  })
}

export const getDepartment = (data: object) => {
  return request.post({ url: '/account/getDepartment', data })
}

export const getAuthAccountList = (data: object) => {
  return request.post({ url: '/role/authAccountList', data })
}

export const editDepartment = (data: object) => {
  return request.post({ url: '/role/authDepartment', data })
}

export const editAuthAccount = (data: object) => {
  return request.post({ url: '/role/authAccount', data })
}

export const getPerson = (data: object) => {
  // return request.post({ url: '/account/getPerson', data })
  return request.post({ url: '/account/searchEmployee', data })
}

export const uspResetPwd = (data: object) => {
  const url = import.meta.env.VITE_APP_USP_API + '/usp-auth/account/pwdReset'
  return request.post({ url, data: { ...data, serverCode: 'bi' } })
}

export const resetPwd = (data: object) => {
  return request.post({ url: '/account/resetPwd', data })
}

export const accountUpdateOnOff = (data: object) => {
  return request.post({ url: '/account/updateOnOff', data })
}

export const getAccountInfo = (data?: object) => {
  return request.post({ url: '/account/info', data })
}

export const getAccountInfoDetail = (data: object) => {
  return request.post({ url: '/account/detail', data })
}

export const registerAccount = (data: object) => {
  return request.post({ url: '/account/register', data })
}
export const updateAccount = (data: object) => {
  return request.post({ url: '/account/update', data })
}
//编辑语言
export const updateLanguage = (data: object) => {
  return request.post({ url: '/account/updateLanguage', data })
}

// 获取账号相关字段明文信息
export const getAccountPlaintext = (data: object = {}) => {
  return request.post({
    url: '/account/getPlaintext',
    data
  })
}

// 获取部门数据
export const getDepartmentList = (data: object = {}) => {
  return request.post({
    url: '/account/getAllDepartment',
    data
  })
}

// 获取用户的权限信息
export const getUserPermission = (data: object = {}) => {
  return request.post({
    url: '/account/getUserDataPermission',
    data
  })
}
